import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IProducts } from '../models/products.model';

export const archivedProductsFeatureKey = 'archivedProducts';

export interface ArchivedProductsState {
  loadArchivedProductsResponse: IProducts[];
  oadArchivedProductsFailure: Error | any;
}

export const initialState: ArchivedProductsState = {
  loadArchivedProductsResponse: undefined,
  oadArchivedProductsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadArchivedProducts, (state, action) => ({
    ...state
  })),
  on(actions.loadArchivedProductsSuccess, (state, action) => ({
    ...state,
    loadArchivedProducts: action.response
  })),
  on(actions.loadArchivedProductsFailure, (state, action) => ({
    ...state,
    loadArchivedProducts: action.error
  }))
);

export const getPastProducts = (state: ArchivedProductsState) => state.loadArchivedProductsResponse;
